module.exports = __webpack_public_path__ + "img/confirm_pc.fa1559fb.gif";